const inbox = {
  statuses: {
    pending: "Ожидают проверки",
    approved: "Одобрено",
    posted: "Опубликовано",
    archived: "В архиве",
  },
  original: {
    title: "Исходная публикация",
    open: "Открыть",
    openOriginal: "Открыть оригинал",
    mediaOnly: "Эта публикация Telegram содержит медиа без текстовой подписи.",
    attachmentAlt: "Вложение публикации Telegram",
    summary: "Краткая информация об оригинале",
    characters_one: "{{formattedCount}} символ",
    characters_few: "{{formattedCount}} символа",
    characters_many: "{{formattedCount}} символов",
    characters_other: "{{formattedCount}} символа",
    mediaAttached: "есть медиа",
  },
  preview: {
    title: "Предпросмотр Telegram",
    empty: "Здесь появится подготовленное сообщение Telegram.",
    label: "Предпросмотр",
    source: "Источник: @{{channel}}",
  },
  ai: {
    toolkit: "Инструменты ИИ для подготовки",
    generating: "Генерация",
    description: "Работает через серверный ИИ. Используйте эти действия только при проверке и редактировании публикаций.",
    draftReady: "Черновик ИИ готов",
    suggestionDescription: "Проверьте предложение «{{action}}» перед применением.",
    before: "До",
    after: "После",
    dismiss: "Отклонить",
    apply: "Применить",
    actions: {
      rephrase: "Перефразировать",
      summarize: "Суммировать",
      translate: "Перевести",
      hashtags: "Хэштеги",
    },
    tone: "Стиль",
    language: "Язык",
    tones: {
      professional: "Профессиональный",
      casual: "Неформальный",
      viral: "Яркий и вирусный",
      news: "Аналитические новости",
      bullets: "Кратко по пунктам",
    },
    languages: {
      english: "Английский",
      spanish: "Испанский",
      russian: "Русский",
      french: "Французский",
      german: "Немецкий",
      chinese: "Китайский",
      arabic: "Арабский",
      persian: "Персидский",
    },
  },
  editor: {
    title: "Подготовленная версия",
    unsaved: "Есть несохранённые изменения",
    saved: "Черновик сохранён",
    copied: "Скопировано",
    copy: "Копировать",
    saveDraft: "Сохранить черновик",
  },
  feedback: {
    draftSaved: "Черновик сохранён.",
    approved: "Публикация одобрена и перемещена в очередь одобренных.",
    approveBeforePublishing: "Одобрите публикацию перед отправкой.",
    destinationRequired: "Настройте и включите назначение Telegram перед публикацией.",
    publishSuccess: "Успешно опубликовано в выбранные назначения Telegram.",
    publishFailed: "Ошибка публикации. Проверьте ошибку назначения и повторите попытку.",
    aiCurationError: "ИИ не смог обработать публикацию. Проверьте настройки провайдера и повторите попытку.",
    aiConnectionError: "Не удалось связаться с настроенным ИИ-провайдером. Повторите попытку.",
    suggestionApplied: "Предложение ИИ применено. Сохраните или одобрите публикацию, когда будете готовы.",
  },
  destinations: {
    selected_one: "Выбрано {{formattedCount}} назначение",
    selected_few: "Выбрано {{formattedCount}} назначения",
    selected_many: "Выбрано {{formattedCount}} назначений",
    selected_other: "Выбрано {{formattedCount}} назначения",
    noneEnabled: "Нет включённых назначений Telegram",
    publishingTo_one: "Публикация в {{formattedCount}} назначение",
    publishingTo_few: "Публикация в {{formattedCount}} назначения",
    publishingTo_many: "Публикация в {{formattedCount}} назначений",
    publishingTo_other: "Публикация в {{formattedCount}} назначения",
    configureToPublish: "Настройте назначение Telegram для публикации",
  },
  actions: {
    approve: "Одобрить",
    publish: "Опубликовать",
    publishing: "Публикация",
    archive: "В архив",
    restore: "Восстановить",
    sync: "Синхронизировать источники",
    syncing: "Синхронизация",
  },
  search: {
    label: "Поиск публикаций или каналов",
    placeholder: "Поиск публикаций или каналов",
  },
  empty: {
    title: "Нет публикаций со статусом «{{status}}»",
    search: "По этому запросу публикации не найдены. Попробуйте другой канал или фразу.",
    default: "Синхронизируйте каналы-источники, чтобы получить свежий контент Telegram.",
  },
  queue: {
    title: "Очередь публикаций",
    count: "{{formattedCount}} · {{status}}",
    mediaPost: "Медиапубликация",
  },
  mobile: {
    reviewPost: "Проверка публикации",
    back: "Назад к списку публикаций",
    position: "{{current}} из {{total}}",
    steps: {
      review: "Проверить",
      approve: "Одобрить",
      publish: "Опубликовать",
    },
    modeLabel: "Режим проверки",
    modes: {
      original: "Оригинал",
      edit: "Редактирование",
      preview: "Предпросмотр",
    },
  },
  accessibility: {
    originalPost: "Исходная публикация",
    postStatus: "Статус публикации",
    toolkit: "Инструменты ИИ для подготовки",
    curatedVersion: "Подготовленная версия",
    postQueue: "Очередь публикаций",
    curatedEditor: "Редактор публикации",
    mobilePostList: "Список публикаций на мобильном",
    reviewPost: "Проверка публикации",
  },
} as const;

export default inbox;
